<script lang="ts">
  import { Button, Col, Modal, ModalBody, Row, Spinner } from "sveltestrap"
  import TxModal from "./TxModal.svelte"
  import { chainId, selectedAccount, web3 } from "svelte-web3"
  import { COREABI } from "../abis/core"
  import { CONFIG } from "../config"
  import { ERC721ABI } from "../abis/erc721"
  import { nFormatter } from "../utils/utils"
  import { ERC20ABI } from "../abis/erc20"
  import { getPairDetail } from "../stores/query"

  export let metaNftId: number;
  export let denominator: object;

  let isOpen = false;
  let delistTxModalOpen = false;
  let delistTxHash = '';
  let amount = '';
  let amountLoaded = false;
  let isMetaNftApproved = false;
  let metaNftApproveTxHash = '';
  let approveMetaNftTxModalOpen = false;
  let isTokenApproved = false;
  let tokenApproveTxHash = '';
  let approveTokenTxModalOpen = false;

  const toggle = () => (isOpen = !isOpen);

  const quote = async () => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    amount = await pilgrim.methods.quoteDelist(metaNftId).call();
    amountLoaded = true;
  };

  const getMetaNftApproved = async () => {
    const metaNft = new $web3.eth.Contract(ERC721ABI, CONFIG[$chainId].META_NFT_ADDRESS);
    isMetaNftApproved = (await metaNft.methods.getApproved(metaNftId).call()).toLowerCase() === CONFIG[$chainId].CORE_ADDRESS.toLowerCase();
  }

  const approveMetaNft = () => {
    const metaNft = new $web3.eth.Contract(ERC721ABI, CONFIG[$chainId].META_NFT_ADDRESS);
    let method = metaNft.methods.approve;
    method(CONFIG[$chainId].CORE_ADDRESS, metaNftId).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        metaNftApproveTxHash = hash;
        approveMetaNftTxModalOpen = true;
      })
      .on('receipt', receipt => {
        isMetaNftApproved = true;
        approveMetaNftTxModalOpen = false;
      })
  }

  const getTokenApproved = async () => {
    const tokenContract = new $web3.eth.Contract(ERC20ABI, $getPairDetail.data.pair.baseToken.id);
    const allowance = $web3.utils.toBN(await tokenContract.methods.allowance($selectedAccount, CONFIG[$chainId].CORE_ADDRESS).call());
    isTokenApproved = allowance.gt($web3.utils.toBN(0));
  }

  const approveToken = () => {
    const tokenContract = new $web3.eth.Contract(ERC20ABI, $getPairDetail.data.pair.baseToken.id);
    tokenContract.methods.approve(
      CONFIG[$chainId].CORE_ADDRESS,
      '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
    ).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        tokenApproveTxHash = hash;
        approveTokenTxModalOpen = true;
      })
      .on('receipt', receipt => {
        isTokenApproved = true;
        approveTokenTxModalOpen = false;
      })
  }

  const delist = () => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    let method = pilgrim.methods.delist;
    method(metaNftId, amount, Math.round(Date.now() / 1000 + 30000)).send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        delistTxHash = hash;
        isOpen = false;
        delistTxModalOpen = true;
      })
  }

  $: if (isOpen) {
    quote();
    getMetaNftApproved();
    getTokenApproved();
  }
</script>


<Button class="nft-detail-share nft-detail-button" on:click={toggle}>
  Delist
</Button>
<Modal class="pil-modal" isOpen={isOpen} {toggle}>
  <ModalBody class="pil-modal-body">
    <Row>
      <Col class="modal-title">
        Delist your NFT
      </Col>
      <Col class="col-auto">
        <img class="icon-large" src="/icons/close.svg" alt="placeholder" on:click={toggle}/>
      </Col>
    </Row>
<!--    <Row>-->
<!--      <Col class="modal-sub-title">-->
<!--        Because the NFT is sold, you are able to refund your round tokens.-->
<!--      </Col>-->
<!--    </Row>-->
    <Row>
      <Col class="modal-sub-title">
        You have to pay
      </Col>
    </Row>
    <Row>
      <Col class="modal-amount-value">
        {amount === '' ? '' : nFormatter(Number.parseInt(amount) / 10 ** denominator.decimals, 3)} {#if !amountLoaded}<Spinner light size="md" />{/if} <span class="modal-amount-unit">{denominator.symbol}</span>
      </Col>
    </Row>
    <Row class="justify-content-center">
      <Col class="col-auto">
        {#if !isMetaNftApproved}
          <Button class="withdraw-button" on:click={approveMetaNft}>
            Approve MetaNFT
          </Button>
        {:else if !isTokenApproved && Number.parseInt(amount) > 0}
          <Button class="withdraw-button" on:click={approveToken}>
            Approve {denominator.symbol}
          </Button>
        {:else}
          <Button class="withdraw-button" on:click={delist}>
            Delist
          </Button>
        {/if}
      </Col>
    </Row>
  </ModalBody>
</Modal>
<TxModal isOpen={delistTxModalOpen} msg="Delist transaction initiated" txHash={delistTxHash}/>
<TxModal isOpen={approveMetaNftTxModalOpen} msg="Approve transaction initiated" txHash={metaNftApproveTxHash}/>
<TxModal isOpen={approveTokenTxModalOpen} msg="Approve transaction initiated" txHash={tokenApproveTxHash}/>
